module.exports = __webpack_public_path__ + "img/icon-phone2.96f77e2c.svg";